import React from 'react'
import clsx from 'clsx'
import { useDrag, useDrop } from 'react-dnd'
import { MdDragHandle } from 'react-icons/md'
import { useTheme } from '@mui/material'
import { ArrowDown2, CloseCircle } from 'iconsax-react'
import useBaseStyles from '../../styles'
import useStyles from './styles'
import Dropdown from '../../../../../atoms/Dropdown'
import { getInbox } from '../../helpers'
import InboxChip from '../InboxSection'
const ITEM_TYPE = 'ANSWER'

const Answer = ({
  id,
  item,
  handleMoveAnswer,
  index,
  questionIndex,
  handleRemoveAnswer,
  inboxes,
  handleAnswerInboxAdd,
  handleMoveAnswerInbox,
  handleRemoveAnswerInbox
}) => {
  const theme = useTheme()
  const dragRef = useDrag({
    item: { type: ITEM_TYPE, id }
  })[1]

  const [{ isOver: isOverTop }, dropTop] = useDrop({
    accept: ITEM_TYPE,
    drop: item => handleMoveAnswer(item.id, id, questionIndex),
    collect: monitor => ({
      isOver: !!monitor.isOver()
    })
  })

  const [{ isOver: isOverBottom }, dropBottom] = useDrop({
    accept: ITEM_TYPE,
    drop: item => handleMoveAnswer(item.id, id, questionIndex),
    collect: monitor => ({
      isOver: !!monitor.isOver()
    })
  })
  const baseClasses = useBaseStyles()

  const classes = useStyles({
    isOverTop,
    isOverBottom
  })

  return (
    <div className={classes.root}>
      <div ref={dragRef} className={classes.drag}>
        <MdDragHandle />
      </div>
      <div ref={dropTop} className={clsx(classes.drop, classes.dropTop)} />

      <div
        ref={dropBottom}
        className={clsx(classes.drop, classes.dropBottom)}
      />

      <label title={item.value} className={classes.label}>
        {item.value}
      </label>

      <div className={classes.answerContainer}>
        {item.inboxes.length === 0 ? (
          <i>Use widget default inbox</i>
        ) : (
          item.inboxes.map(inbox => (
            <InboxChip
              key={inbox}
              id={inbox}
              answer={item}
              item={inbox}
              inboxes={inboxes}
              questionIndex={questionIndex}
              handleMoveAnswerInbox={handleMoveAnswerInbox}
              handleRemoveAnswerInbox={handleRemoveAnswerInbox}
            />
          ))
        )}
        <div className={baseClasses.dropdown}>
          <Dropdown
            options={inboxes.map(t => t.id)}
            renderOption={key => getInbox(inboxes, key)}
            selected={null}
            placeholder='Select inbox'
            onSelect={inboxValue => {
              handleAnswerInboxAdd(questionIndex, item.value, inboxValue)
            }}
            hideAdd
            hideClose
            stringOnly
            disablePortal
          >
            <div className='menu'>
              <div>Add an inbox</div>

              <ArrowDown2 variant='Bold' size={theme.size.base} />
            </div>
          </Dropdown>
        </div>
      </div>

      <CloseCircle
        size={theme.size.base}
        className='delete'
        onClick={() => handleRemoveAnswer(item.value, questionIndex)}
      />
    </div>
  )
}

export default Answer
